import { defineStore } from 'pinia';

export const useEventsStore = defineStore('eventsStorage', {
  actions: {
    sendEvent(name, value) {
      typeof eventSystem != 'undefined' ? eventSystem.notify(name, value) : null
    },
    subscribeToEvent(name, callback) {
      typeof eventSystem != 'undefined' ? eventSystem.subscribe(name, callback) : null
    }
  }
});